import { render, staticRenderFns } from "./Freeback.vue?vue&type=template&id=0d8c1cb8&scoped=true&"
import script from "./Freeback.vue?vue&type=script&lang=js&"
export * from "./Freeback.vue?vue&type=script&lang=js&"
import style0 from "./Freeback.vue?vue&type=style&index=0&id=0d8c1cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8c1cb8",
  null
  
)

export default component.exports